
define('known/models/userModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var User = Backbone.Model.extend({
		urlRoot:"/draftapp/users",
		idAttribute: 'userName',
		defaults: {
			userName: null,
			password: null,
			email: null,
			displayName: null,
			phone: null,
			activated: false,
			phoneActivated: false,
	    },

	    initialize: function() {
	    	
	    },
	    
	    isGuest: function() {
	    	return this.get('userName').toLowerCase() == 'guest';
	    },
	    
	    clearPass : function() {
	    	this.unset("password", {silent: true});
	    	this.unset("curPassword", {silent: true});
	    },
	    
	    prettyDispName: function() {
	    	var dispName = this.get("userName").toLowerCase();
			if(this.get("displayName")){
				dispName = this.get("displayName");
			}
			
			return dispName;
	    }
	});
	
	return User;  
});